import { createAction, handleActions } from 'redux-actions';

/**
 * Action
 * @type {string}
 */
const SNACKBAR_SUCCESS = 'snackbar/SNACKBAR_SUCCESS';
const SNACKBAR_CLEAR = 'snackbar/SNACKBAR_CLEAR';

/**
 * // Action Creators
 * @returns {{type: string}}
 */
export const showSuccessSnackbar = createAction(SNACKBAR_SUCCESS);
export const clearSnackbar = createAction(SNACKBAR_CLEAR);

const initialState = {
  successSnackbarOpen: false,
  successSnackbarMessage: '',
  successSnackbarOption: {
    type: 'success',
  },
};

/**
 * reducer
 */
const uiReducer = handleActions(
  {
    [SNACKBAR_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        successSnackbarOpen: true,
        successSnackbarMessage: payload.message,
        successSnackbarOption: payload.option,
      };
    },

    [SNACKBAR_CLEAR]: (state, { payload }) => {
      return {
        ...state,
        successSnackbarOpen: initialState.successSnackbarOpen,
      };
    },
  },
  initialState
);

export default uiReducer;
